import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './Button';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const checkoutUrl = 'https://jancinas.com/checkouts/cn/hWN5NlkHONW0RzioeC4WJl5d/es-cl?_r=AQAB_muHi4WYbjqTrBznEaayCCMWWHCjPuTB_g6JEDp4-0I&preview_theme_id=186408665457';
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-211">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-212">
        <div className="flex items-center" data-id="element-213">
          <h1 className="text-2xl font-bold text-orange-600" data-id="element-214">
            FinanzasLatinas
          </h1>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-215">
          <a href="#inicio" className="text-gray-700 hover:text-orange-600 font-medium" data-id="element-216">
            Inicio
          </a>
          <a href="#metodo" className="text-gray-700 hover:text-orange-600 font-medium" data-id="element-217">
            El Método
          </a>
          <a href="#beneficios" className="text-gray-700 hover:text-orange-600 font-medium" data-id="element-218">
            Beneficios
          </a>
          <Button href={checkoutUrl} data-id="element-219">Empezar Ahora</Button>
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-220">
          {isMenuOpen ? <XIcon size={24} data-id="element-221" /> : <MenuIcon size={24} data-id="element-222" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white px-4 py-2 shadow-md" data-id="element-223">
          <nav className="flex flex-col space-y-4 pb-4" data-id="element-224">
            <a href="#inicio" className="text-gray-700 hover:text-orange-600 font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-225">
              Inicio
            </a>
            <a href="#metodo" className="text-gray-700 hover:text-orange-600 font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-226">
              El Método
            </a>
            <a href="#beneficios" className="text-gray-700 hover:text-orange-600 font-medium py-2" onClick={() => setIsMenuOpen(false)} data-id="element-227">
              Beneficios
            </a>
            <Button fullWidth href={checkoutUrl} data-id="element-228">
              Empezar Ahora
            </Button>
          </nav>
        </div>}
    </header>;
};